import React, { ReactNode } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "../../context/AuthProvider";
import logoImage from '../../assets/eucomex-logo.png';

interface ProtectedRouteProps {
    allowedRoles: string[];
    children?: ReactNode;
}

const ProtectedRoute = ({ allowedRoles, children }: ProtectedRouteProps) => {
    const { role, fetchingRole } = useAuthContext();

    if (fetchingRole) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh"
                }}
            >
                <img src={logoImage} alt="Loading..." />
            </div>
        );
    }

    // Redirect unauthorized users (including cases where role is null after fetching)
    if (!role || !allowedRoles.includes(role)) {
        return <Navigate to="/unauthorized" replace />;
    }

    // Render children if the role is authorized
    return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;
